"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSettingsDefaultValue = exports.getSettingsValue = void 0;
var tslib_1 = require("tslib");
var generateKey_1 = require("../../generateKey");
var paramShouldInheritDesktop_1 = require("../../utils/paramShouldInheritDesktop");
var translationDefaultFunction_1 = require("./translationDefaultFunction");
var ValueSerializer_1 = require("./ValueSerializer");
var serializer = new ValueSerializer_1.ValueSerializer();
function getSettingsValueBase(values, param, options) {
    if (options === void 0) { options = {}; }
    var isTranslatableParam = (0, generateKey_1.isParamTranslatable)(param);
    var keys = (0, generateKey_1.generateKeyVariations)(param, {
        isMobile: options.isMobile,
        language: isTranslatableParam ? options.language : undefined,
    });
    var shouldInheritDesktop = (0, paramShouldInheritDesktop_1.paramShouldInheritDesktop)(param);
    var value;
    if (isTranslatableParam) {
        if (typeof values[keys.languageAndMobile] !== 'undefined') {
            value = values[keys.languageAndMobile];
        }
        else if (shouldInheritDesktop &&
            typeof values[keys.language] !== 'undefined') {
            value = values[keys.language];
        }
    }
    else {
        if (typeof values[keys.mobile] !== 'undefined') {
            value = values[keys.mobile];
        }
        else if (shouldInheritDesktop &&
            typeof values[keys.original] !== 'undefined') {
            value = values[keys.original];
        }
    }
    return serializer.deserialize(param, value);
}
var wasPublicDataScopeDeprecationMessageShown = false;
function getSettingsValue(publicData, param, _a, scope) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.useDefaultValue, useDefaultValue = _b === void 0 ? true : _b, options = tslib_1.__rest(_a, ["useDefaultValue"]);
    if (scope === void 0) { scope = 'COMPONENT'; }
    var storage = publicData;
    if (!publicData.COMPONENT) {
        if (!wasPublicDataScopeDeprecationMessageShown) {
            console.warn('`getSettingsValue` or `getSettingsValues` should accept whole public data object. Probably, data was passed only for one scope.');
            wasPublicDataScopeDeprecationMessageShown = true;
        }
        storage = {
            COMPONENT: publicData,
            APP: {},
        };
    }
    var shouldInheritFromAppScope = scope === 'COMPONENT' && param.inheritFromAppScope;
    var value = getSettingsValueBase(storage[scope], param, options);
    if (typeof value === 'undefined' && shouldInheritFromAppScope) {
        value = getSettingsValueBase(storage.APP, param, options);
    }
    if (useDefaultValue &&
        param.getDefaultValue &&
        typeof value === 'undefined') {
        return getSettingsDefaultValue(storage, scope, param, options);
    }
    return value;
}
exports.getSettingsValue = getSettingsValue;
function getSettingsDefaultValue(values, scope, param, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var t = (_a = options.t) !== null && _a !== void 0 ? _a : (0, translationDefaultFunction_1.getTranslationDefaultFunction)({
        environmentLabel: (_b = options.environmentLabel) !== null && _b !== void 0 ? _b : '`getSettingsValue` function',
    });
    return param.getDefaultValue({
        isMobile: options.isMobile,
        isRTL: options.isRTL,
        t: t,
        presetId: options.presetId,
        experiments: options.experiments,
        getSettingParamValue: function (settingParam, overrides) {
            if (overrides === void 0) { overrides = {}; }
            return getSettingsValue(values, settingParam, tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, options), overrides), { t: t, useDefaultValue: false }), scope);
        },
    });
}
exports.getSettingsDefaultValue = getSettingsDefaultValue;
//# sourceMappingURL=getSettingsValue.js.map